import { useQuery } from "@tanstack/react-query";
import { getAgreementErpPlansService } from "./service";
import { GetAgreementErpPlansResult } from "./types";

export const agreementErpPlansQueryKey = (agreementId: string | null) =>
  ["integration", "agreement-erp-plans", agreementId] as const;

export function useAgreementErpPlansQuery(agreementId: string | null) {
  return useQuery<GetAgreementErpPlansResult>({
    queryKey: agreementErpPlansQueryKey(agreementId),
    queryFn: () => getAgreementErpPlansService(agreementId!),
    enabled: !!agreementId,
  });
}
